import { makeStyles, Theme, createStyles, alpha } from '@material-ui/core';

import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        bottomLine: {
            padding: '3px 0',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
        },
        listBox: {
            marginTop: 0,
            padding: 0,
        },
        dropdownItem: {
            padding: 0,
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: alpha(theme.palette.primary.main, 0.16),
            },
        },
        selectedDropdownItem: {
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
        },
        paper: {
            marginTop: 0,
        },
        usersDialog: {
            overflowY: 'auto',
            '& .MuiDialog-paperWidthLg': {
                maxWidth: 936,
                minWidth: 936,
            },
        },
        percentageString: {
            position: 'absolute',
            left: '50px',
            top: '21px',
            color: 'red',
        },
        formInnerContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: '40px',
            //width: '1075px',
        },
        leftContainer: {
            width: '67%',
        },
        sectionTitle: {
            fontSize: '10px',
            fontWeight: 'normal',
            letterSpacing: '1.25px',
            marginTop: '30px',
        },
        inputContainer: {
            marginBottom: 30,
            width: '100%',
            //width: '348px',
            /* '& .MuiInputBase-root.MuiFilledInput-root.Mui-disabled': {
                color: theme.palette.secondary.dark,
                backgroundColor: theme.palette.secondary.light,
            }, */
        },
        phoneInput: {
            margin: '0',
            height: '35px',
        },
        halfFormInputContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 30,
        },
        halfFormInput: {
            width: '48%',
        },
        percentageInput: {
            width: '164px',
            marginRight: '20px',
        },
        rightContainer: {
            width: '28%',
            padding: '0 10px',
            backgroundColor: alpha(theme.palette.secondary.light, 0.3),
            borderLeft: `1px solid ${theme.palette.secondary.light}`,
            height: '480px',
        },
        uploadLogoContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'center',
            alignItems: 'center',
            margin: '10px 0 -4.5% 0',
            height: 158,
        },
        logo: {
            width: '95px',
            height: '95px',
            borderRadius: '47.5px',
            objectFit: 'cover',
        },
        uploadLogoTextContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'center',
            width: '160px',
            marginTop: '10px',
            marginLeft: '-8px',
            zIndex: 1,
        },
        contactPersonsContainer: {
            marginTop: '-65px',
        },
        formContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            backgroundColor: theme.palette.common.white,
        },
        dialogTitle: {
            display: 'inline-block',
            marginLeft: 139,
        },
        coolBoxContainer: {
            marginTop: -10,
            '& label:first-child span.MuiTypography-root': {
                marginLeft: 15,
            },
            '& label:last-child span.MuiTypography-root': {
                fontSize: 14,
            },
        },
        pymentSubmit: {
            position: 'absolute',
            top: 10,
            margin: 0,
            right: 12,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: 250,
            '& > span': {
                color: theme.palette.text.secondary,
                fontSize: 14,
                marginRight: 10,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
            },
            '& button': {
                minWidth: 'auto',
            },
        },
        restaurantName: {
            position: 'absolute',
            top: 20,
            margin: 0,
            right: 12,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: 250,
            '& span': {
                color: theme.palette.text.secondary,
                fontSize: 14,
                marginRight: 10,
            },
        },
    })
);
